import React, { useState } from "react";
import axios from "axios";

function BuyCallingCard() {
  const [cardType, setCardType] = useState("");
  const [ownerId, setOwnerId] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [cardId, setCardId] = useState('');
  const [minutes, setMinutes] = useState('');
  const [sessionStartTime, setStartTime] = useState('');
  const [sessionEndTime, setEndTime] = useState('');
  const apikey = "17ea379f850d4360ad2065ef705509f2";

  const handleCardTypeChange = (event) => {
    setCardType(event.target.value);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError(null);
    setSuccess(false);
    if (!cardType) {
      setError('Please select a card type');
      setLoading(false);
      return;
    }
    if (!ownerId) {
      setError('Please enter an owner ID');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(
        "https://callgeeptapi.azure-api.net/callgeept/createCallingCard",
        //"http://localhost:7071/api/createCallingCard",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
            "Access-Control-Allow-Methods": "GET, POST, PUT, DELETE, OPTIONS",
            "Access-Control-Allow-Headers": "Content-Type, Authorization",
            "Access-Control-Allow-Credentials": "true"
          },
          body: JSON.stringify({
            card_type: cardType, 
            owner_id: ownerId,
            "subscription-key": apikey
          }
          ),
        });
      setSuccess('Calling card created successfully!');
    } catch (error) {
      setError('Error creating calling card' + error.message);
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleAddMinutes = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');

    if (!cardId) {
      setError('Please enter a card ID');
      setLoading(false);
      return;
    }

    if (!ownerId) {
      setError('Please enter an owner ID');
      setLoading(false);
      return;
    }

    if (!minutes) {
      setError('Please select a number of minutes');
      setLoading(false);
      return;
    }
    try {
      const response = await fetch(
        //'http://localhost:7071/api/reloadCallingCard', 
        'https://callgeeptapi.azure-api.net/callgeept/reloadCallingCard',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Access-Control-Allow-Origin': '*',
            'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
            'Access-Control-Allow-Headers': 'Content-Type, Authorization',
          },
          body: JSON.stringify({
            card_id: cardId,
            owner_id: ownerId,
            minutes: minutes
          }),
        });
      setSuccess('Minutes added successfully!');
      console.log(response.data);
    } catch (error) {
      setError('Error adding minutes' + error.message);
      console.error(error);
    }
    finally {
      setLoading(false);
    }
  };
  const handleAddSessionSubmit = async (event) => {
    event.preventDefault();
    const response = await fetch(
      //'http://localhost:7071/api/addSessionToCallingCard'
      'https://callgeeptapi.azure-api.net/callgeept/addSessionToCallingCard',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
          'Access-Control-Allow-Headers': 'Content-Type, Authorization',
        },
        body: JSON.stringify(
          { 
            card_id: cardId, 
            owner_id: ownerId, 
            session_end_time: sessionEndTime, 
            session_start_time: sessionStartTime }
        ),
      });
    if (response.ok) {
      setSuccess('Session added successfully!');
    } else {
      setError('Failed to add session.');
    }
  };



  return (
    <div>
      <div className={success ? 'success-bar' : error ? 'error-bar' : ''} style={{ backgroundColor: success ? 'lightgreen' : error ? 'lightcoral' : '' }}>
        {success ? <p>{success}</p> : error ? <p>{error}</p> : null}
      </div>
      <div>
        <h1>Buy Calling Card</h1>
        <form onSubmit={handleSubmit}>
          <div>
            <label htmlFor="cardType">Card Type:</label>
            <select id="cardType" value={cardType} onChange={handleCardTypeChange}>
              <option value="">Select a card type</option>
              <option value="5_min">5 Minute Card</option>
              <option value="30_min">30 Minute Card</option>
              <option value="60_min">60 Minute Card</option>
              <option value="120_min">120 Minute Card</option>
              <option value="5_min_monthly">5 Minute Monthly Card</option>
              <option value="30_min_monthly">30 Minute Monthly Card</option>
              <option value="60_min_monthly">60 Minute Monthly Card</option>
              <option value="120_min_monthly">120 Minute Monthly Card</option>
            </select>
          </div>
          <div>
            <label htmlFor="ownerId">Owner ID:</label>
            <input
              type="text"
              id="ownerId"
              value={ownerId}
              onChange={(event) => setOwnerId(event.target.value)}
            />
          </div>
          <button type="submit" disabled={loading}>
            {loading ? "Creating..." : "Create"}
          </button>
        </form>
      </div>
      <div>
        <h2>Add Minutes to Existing Card</h2>
        <form onSubmit={handleAddMinutes}>
          <label>
            Card ID:
            <input type="text" value={cardId} onChange={(e) => setCardId(e.target.value)} />
          </label>
          <br />
          <label>
            Owner ID:
            <input type="text" value={ownerId} onChange={(e) => setOwnerId(e.target.value)} />
          </label>
          <br />
          <label>
            Minutes:
            <select value={minutes} onChange={(e) => setMinutes(e.target.value)}>
              <option value="">Select Minutes</option>
              <option value="5">5</option>
              <option value="30">30</option>
              <option value="60">60</option>
              <option value="120">120</option>
            </select>
          </label>
          <br />
          <button type="submit" disabled={loading}>
            {loading ? "Adding..." : "Add Minutes"}
          </button>
        </form>
      </div>
      <div>
        <h2>Add Session to Existing Card</h2>
        <form onSubmit={handleAddSessionSubmit}>
          <label>
            Card ID:
            <input type="text" value={cardId} onChange={(e) => setCardId(e.target.value)} />
          </label>
          <br />
          <label>
            Owner ID:
            <input type="text" value={ownerId} onChange={(e) => setOwnerId(e.target.value)} />
          </label>
          <br />
          <label>
            Start Time:
            <input type="datetime-local" value={sessionStartTime} onChange={(e) => setStartTime(e.target.value)} />
          </label>
          <br />

          <label>
            End Time:
            <input type="datetime-local" value={sessionEndTime} onChange={(e) => setEndTime(e.target.value)} />
          </label>
          <br />
          <button type="submit">Add Session</button>
        </form>
      </div>

    </div>

  );
}

export default BuyCallingCard;